import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { TransactionFilterKey } from 'api/Transaction/Types/Transaction'
import { TransactionType } from 'api/Wallet/Types/TransactionTypeDto'
import { FilterType } from 'components/Filter'
import { getIBTransactionsFilters } from 'components/Filter/getIBTransactionsFilters'
import { initialState } from 'store/grid'
import { links } from 'utils/featureToggles'
import { FilterLogic } from 'utils/QueryHelpers'

import { transactionIBCashBackColumns } from './transactionIBCashBackColumns'
import TransactionIBTransactionsOverview from './TransactionIBTransactionsOverview'

const TransactionIBCashBacksOverview = (): JSX.Element => {
  return (
    <>
      <Breadcrumbs
        crumbs={[{ title: 'Transactions - IB CashBacks', link: links.transactionIBCashBacks.url }]}
      />
      <TransactionIBTransactionsOverview
        filterType={FilterType.IB_CASHBACK}
        columns={transactionIBCashBackColumns}
        filterFields={getIBTransactionsFilters}
        query={createTransactionIBCashBacksQuery()}
      />
    </>
  )
}

const createTransactionIBCashBacksQuery = () => {
  const initialGridState = initialState()

  return {
    ...initialGridState.filter,
    logic: initialGridState.filter.logic,
    defaultFilters: {
      logic: FilterLogic.OR,
      filters: [
        {
          field: TransactionFilterKey.type,
          operator: '==',
          value: TransactionType.IBCashBacks,
        },
      ],
    },
  }
}

export default TransactionIBCashBacksOverview
